import React, { useEffect, useState } from "react";
import {
  IoMdCheckmarkCircle,
  IoIosCloseCircle,
  IoMdArrowDropupCircle,
} from "react-icons/io";
import { formatAmount } from "../../../Utility/functions/Helper";
import moment from "moment-timezone";
import { MdOutlineMotionPhotosOff } from "react-icons/md";
import void2 from "../../../image/Void.png";
import dnp from "../../../image/dnp.png";
import { isMobile } from "react-device-detect";
import { FaBan } from "react-icons/fa";

const PendingBets = ({ pending, isPending }) => {
  const [value, setValue] = useState(50); // Initial value set to 50

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
  };

  const min = 0;
  const max = 100;

  const percentage = ((value - min) / (max - min)) * 100;
  const backgroundStyle = {
    background: `linear-gradient(to right, #179624 ${percentage}%, #ED1A3B ${percentage}%)`,
  };

  const backgroundStyleOpen = {
    background: `linear-gradient(to right, #ED1A3B ${percentage}%, #179624 ${percentage}%)`,
  };

  const PendingData = pending;

  return (
    <>
      {isPending && (
        <div className="mainbox-pending margint_main">
          <div className="row g-4">
            {PendingData?.map((item) => {
              const playerData = item?.playerData;

              const eventIds = playerData?.map(
                (data) => data?.playerevent?.eventId
              );

              const uniqueEventIds = new Set(eventIds);

              let playerlength = item?.playerData?.length;

              let money = item?.wager;

              // console.log("item",item.payoutDetail);

              return (
                <div className="col-md-12">
                  <div className="mainbox_inner">
                    <div className="first_main">
                      <div className="main_left">
                        <h3 className="head_p">Entry:</h3>
                        <p>{item?.id}</p>
                      </div>
                      <div className="main_right">
                        <h4 style={{ overflow: "none!important" }}>
                          Entry Fee: <span> ${formatAmount(item?.wager)}</span>
                        </h4>
                      </div>
                    </div>

                    {/* payout structure */}
                    <div>
                      {item?.payoutDetail.map((data,key)=>{
                        // debugger
                        return(
                      <div className="second_main">
                          <p>
                            {data?.players} Correct &nbsp; {data?.multiplier}{"x"} &nbsp;Pays:{" "}
                            <span>${formatAmount(data?.amount?.toFixed(2))}</span>
                          </p>
                        </div>
                        )
                      })}
                        </div>

                    <h3 className="head_p mb-4">Players:</h3>
                    {playerData?.map((player) => {
                      const teamHid = player?.teamH?.teamId;

                      const teamAid = player?.teamA?.teamId;

                      const teamHname = player?.teamH?.abv;

                      const teamAname = player?.teamA?.abv;

                      const Game_status = player?.status;

                      const result = player?.defineresult;

                      const finalpoint = player.finalpoints;

                      const rangeWidth =
                        (player.finalpoints / (player.points * 2)) * 100;

                      // console.log("status",result);

                      return (
                        <div
                          className={
                            player?.defined && result == "win"
                              ? "main_item_card green_item"
                              : player?.defined && result == "lose"
                              ? "main_item_card red_item"
                              : "main_item_card"
                          }
                        >
                          <div className="item_card">
                            <div className="item_left">
                              <div className="middle_div">
                                <div className="name_card name_wrap">
                                  <h3
                                    style={{
                                      marginLeft: isMobile ? "0px" : "40px",
                                    }}
                                  >
                                    {player?.name}
                                  </h3>
                                  {player?.game_type == 2 ? (
                                    <p>{player?.single_event}</p>
                                  ) : (
                                    <p>
                                      <span>{player?.position}</span> |{" "}
                                      {player?.team == teamHid
                                        ? teamHname
                                        : teamAname}{" "}
                                      {""}
                                      {player?.team == teamHid
                                        ? "VS"
                                        : "@"}{" "}
                                      {""}
                                      {player?.team == teamHid
                                        ? teamAname
                                        : teamHname}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="item_right">
                              <p>
                                {moment(player?.event_time).format(
                                  "MMM DD, h:mm a"
                                )}
                              </p>
                            </div>
                          </div>
                          <div className="item_bottom item_card mt-2">
                            <div className="item_left">
                              <div className="icon-check">
                                {player?.void ? (
                                  <div className="item_icon void_icon">
                                    <FaBan
                                      style={{
                                        marginTop: isMobile ? "-5px" : "-10px",
                                      }}
                                    />
                                  </div>
                                ) : player?.dnp && !player?.result ? (
                                  <div className="item_icon">
                                    <img
                                      alt="bettdraft"
                                      src={dnp}
                                      style={{
                                        height: "35px",
                                        marginTop: "-15px",
                                      }}
                                    />
                                  </div>
                                ) : player?.defined && result == "win" ? (
                                  <div className="item_icon">
                                    <IoMdCheckmarkCircle />
                                  </div>
                                ) : player?.defined && result == "lose" ? (
                                  <div className="item_icon">
                                    <IoIosCloseCircle />
                                  </div>
                                ) : (
                                  <div
                                    className="item_icon"
                                    style={{
                                      visibility: "hidden",
                                      height: "35px",
                                    }}
                                  ></div>
                                )}
                              </div>

                              <div className="middle_div">
                                <div className="name_card">
                                  {player?.isMore ? (
                                    <IoIosCloseCircle
                                      style={{ color: "#C02640" }}
                                    />
                                  ) : (
                                    <IoMdCheckmarkCircle />
                                  )}
                                  {/* <IoMdCheckmarkCircle /> */}
                                  <div
                                    className={
                                      player?.defined
                                        ? "w-100 range_div1 game_completed"
                                        : "w-100 range_div1 game_completed"
                                    }
                                  >
                                    <input
                                      type="range"
                                      id="myRange"
                                      min={min}
                                      max={max}
                                      value={value}
                                      // onChange={handleChange}
                                      style={
                                        player?.isMore
                                          ? backgroundStyleOpen
                                          : backgroundStyle
                                      }
                                    />
                                    <p>
                                      {player.points} {player.marketAbv}{" "}({player?.multiplier}x)
                                    </p>
                                    <div
                                      className="arrow_icon"
                                      style={{
                                        left:
                                          rangeWidth > 100
                                            ? "99%"
                                            : `calc(${rangeWidth}% - 10px)`,
                                        position: "relative",
                                        top: "-33px",
                                      }}
                                    >
                                      <span
                                        className="finalpoint"
                                        style={{
                                          display: "block",
                                          marginTop: isMobile
                                            ? "-15px"
                                            : "-18px",
                                          color: "#000",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {finalpoint}
                                      </span>
                                      <IoMdArrowDropupCircle />
                                    </div>
                                  </div>
                                 {player?.isMore ? (
                                    <IoMdCheckmarkCircle
                                    style={{ color: "#179624" }}
                                  />
                                  ) : (
                                    <IoIosCloseCircle />
                                  )}
                                  {/* <IoIosCloseCircle /> */}
                                </div>
                              </div>
                            </div>
                            <div className="item_right">
                              <a className={Game_status == 2?"btn_light_inplay":"btn_light"}>
                                {player?.defined
                                  ? "Completed"
                                  : Game_status == 2
                                  ? "in Play"
                                  : Game_status == 6
                                  ? "Postponed"
                                  : Game_status == 7
                                  ? "Cancelled"
                                  : "Scheduled"}
                              </a>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default PendingBets;
